export default "__VITE_ASSET__Bp5eBbVz__"